<div class="grid grid-cols-2 xl:grid-cols-4 gap-6">
  <div
    *ngFor="
      let product of products()
        | paginate : {
            itemsPerPage: totalElements(),
            currentPage: currentPage(),
            totalItems: totalItems()
          };
      let i = index
    "
    class="flex flex-col h-full"
  >
    <div class="mr-0 px-0 md:mr-4 md:last:mr-0 xl:px-0 grow flex flex-col">

      <!-- Product image -->
      <div
        class="relative cursor-pointer rounded border overflow-hidden md:h-[254px] w-full flex justify-center items-center"
      >
        <img
          [routerLink]="['/stores', storeName() | lowercase, product.product.product_code]"
          src="{{ product?.product.image_data[0]?.image_source }}"
          alt="product"
          class="rounded-md h-[124px] md:h-full object-cover overflow-hidden"
        />
        <p
          *ngIf="product.product.quantity_in_stock === 0"
          class="absolute bg-[#FEF3F2] text-[#D92D20] top-0 left-2 lg:top-5 lg:left-3 p-1 mt-3 rounded text-xs lg:text-sm font-medium"
        >
          Out of stock
        </p>
      </div>

      <!-- Product name -->
      <a
        [routerLink]="['/stores', storeName() | lowercase, product.product.product_code]"
        class="py-2 font-medium text-sm grow text-zestLabel cursor-pointer hover:text-green-600 transition-colors"
      >
        {{ product?.product.product_name }}
      </a>

      <!-- Price -->
      <h4
        *ngIf="product?.product.discount; else regularPrice"
        class="pb-1 text-zestBlack text-base font-medium"
      >
        {{ product?.product.discounted_price | currency : "₦ " }}
      </h4>
      <ng-template #regularPrice>
        <h4 class="text-base font-medium text-zestBlack pb-8">
          {{ product?.product.price | currency : "₦ " }}
        </h4>
      </ng-template>

      <!-- Discount badge -->
      <div class="flex items-center" *ngIf="product?.product.discount">
        <h5 class="line-through text-sm font-medium text-zestLabel">
          {{ product?.product.price | currency : "₦ " }}
        </h5>
        <span class="inline-block bg-zestGreen text-sm text-zestWhite font-medium p-1 ml-2 rounded">
          -{{ product?.product.discount }} %
        </span>
      </div>

      <!-- Cart controls -->
      <ng-container
        *ngIf="store.getItemCount(product?.product.product_code); else showCartButton"
      >
        <div class="flex justify-between items-center w-full mx-auto">
          <!-- Subtract -->
          <button
            *ngIf="product?.product.productVariant; else subvariant"
            [routerLink]="['/stores', storeName() | lowercase, product.product.product_code]"
            class="bg-zestBlack text-white w-12 text-lg h-12 rounded-lg py-2 px-[15px] mt-3 mb-8"
          >-</button>
          <ng-template #subvariant>
            <button
              (click)="store.subtractCartItem(product)"
              class="bg-zestBlack text-white w-12 text-lg h-12 rounded-lg py-2 px-[15px] mt-3 mb-8"
            >-</button>
          </ng-template>

          <p class="px-[14px] pb-4 text-base" *ngIf="cart() !== null">
            {{ store.getItemCount(product?.product.product_code) }}
          </p>

          <!-- Add -->
          <button
            *ngIf="product.product.productVariant; else plusvariant"
            [routerLink]="['/stores', storeName() | lowercase, product?.product.product_code]"
            class="bg-zestBlack text-white w-12 text-lg h-12 rounded-lg py-2 px-[15px] mt-3 mb-8"
          >+</button>
          <ng-template #plusvariant>
            <button
              (click)="store.addCartItem(product)"
              class="bg-zestBlack text-white w-12 text-lg h-12 rounded-lg py-2 px-[15px] mt-3 mb-8"
            >+</button>
          </ng-template>
        </div>
      </ng-container>

      <!-- Add to cart button (not yet in cart) -->
      <ng-template #showCartButton>
        <button
          *ngIf="product?.product.productVariant; else noVariantBtn"
          [routerLink]="['/stores', storeName() | lowercase, product?.product.product_code]"
          class="w-full text-sm px-3 md:text-base rounded py-2 md:px-6 mt-3 mb-8 bg-zestWhite h-12 border-[1.2px] border-zestBlack hover:border-none hover:bg-zestBlack text-zestBlack font-medium hover:text-zestBg"
        >
          Add to cart
        </button>
        <ng-template #noVariantBtn>
          <button
            (click)="addToCart.emit({ code: product?.product.product_code, index: i })"
            class="w-full text-sm px-3 md:text-base rounded py-2 md:px-6 mt-3 mb-8 bg-zestWhite h-12 border-[1.2px] border-zestBlack hover:border-none hover:bg-zestBlack text-zestBlack font-medium hover:text-zestBg"
          >
            Add to cart
          </button>
        </ng-template>
      </ng-template>

    </div>
  </div>
</div>

<!-- Pagination -->
<div class="flex items-center justify-between mt-4">
  <p>Showing page {{ currentPage() }} of {{ lastPage() }}</p>
  <pagination-controls
    class="custom-pagination items-center mt-2"
    previousLabel="Prev"
    (pageChange)="pageChanged.emit($event)"
  ></pagination-controls>
</div>
